import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import Select from 'react-select';
import TOPBAR from "../../components/TopBar";
import SEARCHBAR from "../../components/SeachBar";
import MENUBAR from "../../components/Menu";
import FOOTER from "../../components/Footer";
import RoughCountryCard from '../../components/Cards/rough-country-card';
import Pagination from 'react-bootstrap/Pagination';
import { ShimmerThumbnail } from "react-shimmer-effects";
import Collapse from 'react-bootstrap/Collapse';
import { buildBrandPageSchema } from '../../utils/brandSchema';

// Rough Country is not listed on /brands, so the breadcrumb is Home › Rough Country
const ROUGH_COUNTRY_URL = "https://www.extremeperformance.com/rough-country";
const roughCountrySchema = buildBrandPageSchema({
    name: "Rough Country",
    url: ROUGH_COUNTRY_URL,
    description: "Explore the full range of Rough Country",
    logo: "https://media.roughcountry.com/media/catalog/product/r/c/rc-logo-stamp2.jpg",
    breadcrumb: [
        { name: "Home", url: "https://www.extremeperformance.com/" },
        { name: "Rough Country", url: ROUGH_COUNTRY_URL },
    ],
});

export default function RoughCountry() {
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
    const PRODUCTS_PER_PAGE = 28;
    const MAX_PAGES_DISPLAY = 10;

    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(() => {
        const savedPage = localStorage.getItem('rough_currentPage');
        return savedPage ? JSON.parse(savedPage) : 1;
    });

    const [offset, setOffset] = useState(() => {
        const savedOffset = localStorage.getItem('rough_offset');
        return savedOffset ? JSON.parse(savedOffset) : 0;
    });

    const [totalPages, setTotalPages] = useState(1);
    const [totalProducts, setTotalProducts] = useState(0);
    const [isHidden, setIsHidden] = useState(false);
    const [selectedManufacturers, setSelectedManufacturers] = useState([]);
    const [showInStockOnly, setShowInStockOnly] = useState(true);
    const [sortingValue, setSortingValue] = useState(1);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [availableCategories, setAvailableCategories] = useState([]);
    const [openCategory, setOpenCategory] = useState(false);
    const [availableManufacturers, setAvailableManufacturers] = useState([]);
    const [openManufacturer, setOpenManufacturer] = useState(true);
    const [applyTrigger, setApplyTrigger] = useState(false);
    const [selectedLifts, setSelectedLifts] = useState([]);
    const [availableLifts, setAvailableLifts] = useState([]);
    const [openLift, setOpenLift] = useState(false);
    const [filterClass, setFilterClass] = useState('');
    // const [openVehicle, setOpenVehicle] = useState(false);

    const storedVehicle = JSON.parse(localStorage.getItem('vehical_details') || '{}');
    const [openVehicle, setOpenVehicle] = useState(Object.keys(storedVehicle).length > 0);

    const [years, setYears] = useState([]);
    const [makes, setMakes] = useState([]);
    const [models, setModels] = useState([]);
    const [submodels, setSubmodels] = useState([]);
    const [loadingYears, setLoadingYears] = useState(false);
    const [loadingMakes, setLoadingMakes] = useState(false);
    const [loadingModels, setLoadingModels] = useState(false);
    const [loadingSubmodels, setLoadingSubmodels] = useState(false);
    const [year, setYear] = useState(storedVehicle?.year || '');
    const [make, setMake] = useState(storedVehicle?.make || '');
    const [model, setModel] = useState(storedVehicle?.model || '');
    const [submodel, setSubmodel] = useState(storedVehicle?.variant || '');
    const [yearLabel, setYearLabel] = useState(storedVehicle?.yearLabel || storedVehicle?.year || 'Year');
    const [makeLabel, setMakeLabel] = useState(storedVehicle?.makeLabel || storedVehicle?.make_name || 'Make');
    const [modelLabel, setModelLabel] = useState(storedVehicle?.modelLabel || storedVehicle?.model_name || 'Model');
    const [subLabel, setSubLabel] = useState(storedVehicle?.variantLabel || storedVehicle?.variant_name || 'Submodel');

    const makeRef = useRef(null);
    const modelRef = useRef(null);
    const submodelRef = useRef(null);
    const hasVehicleSelection = !!year && !!make && !!model && !!submodel;


    const startIndex = (currentPage - 1) * PRODUCTS_PER_PAGE + 1;
    const endIndex = Math.min(startIndex + PRODUCTS_PER_PAGE - 1, totalProducts);

    const [cartItems, setCartItems] = useState("");
    const [showMenuSide, setShowMenuSide] = useState("");
    const [ymmError, setYmmError] = useState(false);


    const setValueMenuSideBar = (value) => {
        setShowMenuSide(value);
    };


    useEffect(() => {
        const savedSorting = localStorage.getItem('rough_sortingValue');
        if (savedSorting) setSortingValue(JSON.parse(savedSorting));

        const savedStock = localStorage.getItem('rough_inStockOnly');
        if (savedStock !== null) {
            setShowInStockOnly(JSON.parse(savedStock));
        }

        const savedManufacturers = localStorage.getItem('rough_manufacturers');
        if (savedManufacturers) {
            setSelectedManufacturers(JSON.parse(savedManufacturers));
        }

        const savedCategories = localStorage.getItem('rough_categories');
        if (savedCategories) {
            setSelectedCategories(JSON.parse(savedCategories));
        }

        const savedLifts = localStorage.getItem('rough_lifts');
        if (savedLifts) {
            setSelectedLifts(JSON.parse(savedLifts));
        }

        const savedPage = localStorage.getItem('rough_currentPage');
        const savedOffset = localStorage.getItem('rough_offset');

        if (savedPage) {
            setCurrentPage(JSON.parse(savedPage));
        }

        if (savedOffset) {
            setOffset(JSON.parse(savedOffset));
        }

        setApplyTrigger(prev => !prev);

    }, []);


    useEffect(() => {
        loadYears();
    }, []);

    useEffect(() => {
        if (!storedVehicle?.year) return;

        loadMakes(storedVehicle.year);

        if (!storedVehicle?.make) return;
        loadModels(storedVehicle.year, storedVehicle.make);

        if (!storedVehicle?.model) return;
        loadSubmodels(storedVehicle.year, storedVehicle.model);
    }, []);

    useEffect(() => {
        if (years.length > 0 && year) {
            const found = years.find(opt => String(opt.value) === String(year));
            if (found) setYearLabel(found.label);
        }
    }, [years, year]);

    useEffect(() => {
        if (makes.length > 0 && make) {
            const found = makes.find(opt => String(opt.value) === String(make));
            if (found) setMakeLabel(found.label);
        }
    }, [makes, make]);

    useEffect(() => {
        if (models.length > 0 && model) {
            const found = models.find(opt => String(opt.value) === String(model));
            if (found) setModelLabel(found.label);
        }
    }, [models, model]);

    useEffect(() => {
        if (submodels.length > 0 && submodel) {
            const found = submodels.find(opt => String(opt.value) === String(submodel));
            if (found) setSubLabel(found.label);
        }
    }, [submodels, submodel]);

    useEffect(() => {
        if (!hasVehicleSelection) return;

        localStorage.setItem('vehical_details', JSON.stringify({
            year,
            make,
            model,
            variant: submodel,
            make_name: makeLabel,
            model_name: modelLabel,
            variant_name: subLabel,
        }));
    }, [hasVehicleSelection, year, make, model, submodel, makeLabel, modelLabel, subLabel]);


    useEffect(() => {
        localStorage.setItem('rough_manufacturers', JSON.stringify(selectedManufacturers));
        localStorage.setItem('rough_categories', JSON.stringify(selectedCategories));
        localStorage.setItem('rough_lifts', JSON.stringify(selectedLifts));
        localStorage.setItem('rough_inStockOnly', JSON.stringify(showInStockOnly));
        localStorage.setItem('rough_sortingValue', JSON.stringify(sortingValue));
    }, [selectedManufacturers, selectedCategories, selectedLifts, showInStockOnly, sortingValue]);

    // Load cart items count
    useEffect(() => {
        const storedCartItems = localStorage.getItem('totalCartItems');
        if (storedCartItems) {
            const parsedCartItems = JSON.parse(storedCartItems);
            const numCartItems = Object.values(parsedCartItems);
            const sum = numCartItems.reduce((acc, val) => acc + val, 0);
            setCartItems(sum);
        }
    }, []);

    // Main data fetching effect
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            document.body.classList.add('full-screen-loader');

            try {
                let params = {
                    limit: PRODUCTS_PER_PAGE,
                    page: currentPage,
                    sorting: sortingValue,
                };

                if (showInStockOnly) params.inStock = true;
                if (selectedManufacturers.length > 0) params.manufacturer = selectedManufacturers.join(',');
                if (selectedCategories.length > 0) params.category = selectedCategories.join(',');
                if (selectedLifts.length > 0) params.lift = selectedLifts.join(',');
                if (hasVehicleSelection) {
                    params.year = year;
                    params.make = makeLabel;
                    params.model = modelLabel;
                    params.variant = subLabel;
                }

                const response = await axios.get(`${mainUrl}/api/rough/getAllRoughCountryData`, { params });

                setProducts(response.data.data || []);
                setTotalPages(response.data.totalPages || 1);
                setTotalProducts(response.data.count || 0);
                setIsHidden(true);

                if (response.data.availableManufacturers) {
                    setAvailableManufacturers(response.data.availableManufacturers);
                } else if (availableManufacturers.length === 0 && response.data.data) {
                    const unique = [...new Set(response.data.data.map(p => p.manufacturer))].filter(Boolean);
                    setAvailableManufacturers(unique);
                }

                if (response.data.availableCategories) {
                    setAvailableCategories(response.data.availableCategories);
                } else if (availableCategories.length === 0 && response.data.data) {
                    const unique = [...new Set(response.data.data.map(p => p.category))].filter(Boolean);
                    setAvailableCategories(unique);
                }

                if (response.data.availableLifts) {
                    setAvailableLifts(response.data.availableLifts);
                } else if (availableLifts.length === 0 && response.data.data) {
                    const unique = [...new Set(response.data.data.map(p => p.kit_type))].filter(Boolean);
                    setAvailableLifts(unique);
                }

            } catch (err) {
                console.error("Fetch error:", err);
            } finally {
                setIsLoading(false);
                document.body.classList.remove('full-screen-loader');
            }
        };

        fetchData();
        window.scrollTo({ top: 400, behavior: 'smooth' });

    }, [currentPage, sortingValue, showInStockOnly, applyTrigger]);

    const loadYears = async () => {
        setLoadingYears(true);
        try {
            const { data } = await axios.get(`${mainUrl}/api/getYear`);
            setYears(data?.data || []);
        } catch (err) {
            console.error('Failed to load years', err);
        } finally {
            setLoadingYears(false);
        }
    };

    const loadMakes = async (yr) => {
        if (!yr) return;
        setLoadingMakes(true);
        try {
            const { data } = await axios.get(`${mainUrl}/api/getMakeByYear/${yr}`);
            setMakes(data?.data || []);
        } catch (err) {
            console.error('Failed to load makes', err);
        } finally {
            setLoadingMakes(false);
        }
    };

    const loadModels = async (yr, mk) => {
        if (!yr || !mk) return;
        setLoadingModels(true);
        try {
            const { data } = await axios.get(`${mainUrl}/api/getModelByMake/${yr}/${mk}`);
            setModels(data?.data || []);
        } catch (err) {
            console.error('Failed to load models', err);
        } finally {
            setLoadingModels(false);
        }
    };

    const loadSubmodels = async (yr, md) => {
        if (!yr || !md) return;
        setLoadingSubmodels(true);
        try {
            const { data } = await axios.get(`${mainUrl}/api/getSubModelByModel/${yr}/${md}`);
            setSubmodels(data?.data || []);
        } catch (err) {
            console.error('Failed to load submodels', err);
        } finally {
            setLoadingSubmodels(false);
        }
    };

    const handleYearChange = (option) => {
        if (!option) return;
        setYear(option.value);
        setYearLabel(option.label);
        setMake('');
        setMakeLabel('Make');
        setModel('');
        setModelLabel('Model');
        setSubmodel('');
        setSubLabel('Submodel');
        setMakes([]);
        setModels([]);
        setSubmodels([]);
        // localStorage.removeItem('vehical_details');
        loadMakes(option.value);
        setTimeout(() => makeRef.current?.focus(), 100);
    };

    const handleMakeChange = (option) => {
        if (!option) return;
        setMake(option.value);
        setMakeLabel(option.label);
        setModel('');
        setModelLabel('Model');
        setSubmodel('');
        setSubLabel('Submodel');
        setModels([]);
        setSubmodels([]);
        // localStorage.removeItem('vehical_details');
        loadModels(year, option.value);
        setTimeout(() => modelRef.current?.focus(), 100);
    };

    const handleModelChange = (option) => {
        if (!option) return;
        setModel(option.value);
        setModelLabel(option.label);
        setSubmodel('');
        setSubLabel('Submodel');
        setSubmodels([]);
        // localStorage.removeItem('vehical_details');
        loadSubmodels(year, option.value);
        setTimeout(() => submodelRef.current?.focus(), 100);
    };

    // const handleSubmodelChange = (option) => {
    //     if (!option) return;
    //     setSubmodel(option.value);
    //     setSubLabel(option.label);
    //     // window.location.reload();
    // };

    const handleSubmodelChange = (option) => {
        if (!option) return;
        setSubmodel(option.value);
        setSubLabel(option.label);

        const state = {
            year,
            make,
            model,
            variant: option.value,
            make_name: makeLabel,
            model_name: modelLabel,
            variant_name: option.label,
        };

        localStorage.setItem('vehical_details', JSON.stringify(state));
        window.dispatchEvent(new Event('vehicleUpdated'));
    };

    const clearVehicleFilter = () => {
        setYear('');
        setYearLabel('Year');
        setMake('');
        setMakeLabel('Make');
        setModel('');
        setModelLabel('Model');
        setSubmodel('');
        setSubLabel('Submodel');
        setMakes([]);
        setModels([]);
        setSubmodels([]);
        localStorage.removeItem('vehical_details');
        // window.location.reload();
        window.dispatchEvent(new Event('vehicleUpdated'));

    };

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;

        const newOffset = (page - 1) * PRODUCTS_PER_PAGE;

        setCurrentPage(page);
        setOffset(newOffset);

        localStorage.setItem('rough_currentPage', JSON.stringify(page));
        localStorage.setItem('rough_offset', JSON.stringify(newOffset));
    };


    const getPageNumbers = () => {
        const totalDisplay = Math.min(totalPages, MAX_PAGES_DISPLAY);
        const middle = Math.ceil(totalDisplay / 2);
        let start = Math.max(1, currentPage - middle + 1);
        if (start + totalDisplay - 1 > totalPages) {
            start = Math.max(1, totalPages - totalDisplay + 1);
        }
        return Array.from({ length: totalDisplay }, (_, i) => start + i);
    };

    const handleSorting = (e) => {
        setSortingValue(parseInt(e.target.value));
    };

    const handleStockToggle = () => {
        setShowInStockOnly(prev => !prev);
    };

    const handleManufacturerChange = (mfr) => {
        setSelectedManufacturers(prev =>
            prev.includes(mfr) ? prev.filter(x => x !== mfr) : [...prev, mfr]
        );
    };

    const handleCategoryChange = (cat) => {
        setSelectedCategories(prev =>
            prev.includes(cat) ? prev.filter(x => x !== cat) : [...prev, cat]
        );
    };

    const handleLiftChange = (lift) => {
        setSelectedLifts(prev =>
            prev.includes(lift) ? prev.filter(x => x !== lift) : [...prev, lift]
        );
    };

    // const applyFilters = () => {
    //     setCurrentPage(1);
    //     setOffset(0);
    //     setApplyTrigger(prev => !prev);

    //     setFilterClass('')
    //     document.body.classList.remove('home-layout')

    //     window.scrollTo({ top: 400, behavior: 'smooth' });
    // };

    const applyFilters = () => {
        const partialSelection = year || make || model || submodel;
        const completeSelection = year && make && model && submodel;

        if (partialSelection && !completeSelection) {
            setYmmError(true);
            return;
        }

        setYmmError(false);

        setCurrentPage(1);
        setOffset(0);

        localStorage.setItem('rough_currentPage', JSON.stringify(1));
        localStorage.setItem('rough_offset', JSON.stringify(0));

        setApplyTrigger(prev => !prev);

        setFilterClass('');

        document.body.classList.remove('home-layout');

        window.scrollTo({ top: 400, behavior: 'smooth' });
    };


    useEffect(() => {
        const completeSelection =
            year && make && model && submodel;

        if (completeSelection) {
            setYmmError(false);
        }
    }, [year, make, model, submodel]);

    const selectErrorStyles = {
        control: (base) => ({
            ...base,
            borderColor: 'red',
            boxShadow: 'none',
            '&:hover': {
                borderColor: 'red'
            }
        })
    };

    const clearAllFilters = () => {
        setSelectedManufacturers([]);
        setSelectedCategories([]);
        setSelectedLifts([]);

        clearVehicleFilter();

        setShowInStockOnly(true);
        setSortingValue(1);

        setCurrentPage(1);
        setOffset(0);

        localStorage.setItem('rough_currentPage', JSON.stringify(1));
        localStorage.setItem('rough_offset', JSON.stringify(0));

        setApplyTrigger(prev => !prev);
    };


    const removeManufacturer = (mfr) => {
        setSelectedManufacturers(prev => prev.filter(item => item !== mfr));
    };

    const removeCategory = (cat) => {
        setSelectedCategories(prev => prev.filter(item => item !== cat));
    };

    const removeLift = (lift) => {
        setSelectedLifts(prev => prev.filter(item => item !== lift));
    };


    const showFiltersClick = () => {
        setFilterClass('active-filter')
        document.body.classList.add('home-layout')

    }
    const hideFilterClass = () => {
        setFilterClass('')
        document.body.classList.remove('home-layout')
    }


    return (
        <>
            <Helmet>
                <title>Rough Country</title>
                <meta name="description" content="Explore the full range of Rough Country" />
                <script type="application/ld+json">{JSON.stringify(roughCountrySchema)}</script>
            </Helmet>

            <TOPBAR isHidden={isHidden} />
            <SEARCHBAR setValueMenuSideBar={setValueMenuSideBar} cartItemsdata={cartItems} />
            <MENUBAR showMenuSide={showMenuSide} setValueMenuSideBar={setValueMenuSideBar} />

            <div className="main-inner-banner">
                <div className="parformane-bar">
                    <div className="container d-flex justify-content-between">
                        <ul className="p-0 m-0 listing-parmofamne">
                            <li><a href="/">Home /</a></li>
                            <li className="active-bread text-decoration-none"><a href="#">Rough Country</a></li>
                        </ul>
                    </div>
                </div>
                <h2 className="text-center txt-main-listing">Rough Country</h2>
            </div>

            <section className="main-section-lsting">
                <div className="container">

                    <div className="row">
                        {/* Sidebar */}
                        <div className="col-lg-3">
                            {/* <div className="main-outer-filter"> */}
                            <div className={`main-outer-filter ${filterClass}`}>

                                <div className="filter-crose" id="close-bar">
                                    <button className="abc" onClick={hideFilterClass}>
                                        <img src="/images/x-mark.svg" alt="img" height="100%" width="100%" />
                                    </button>
                                </div>

                                <div className="price-filter filter-button">
                                    <button className="btn btn-danger" onClick={applyFilters}>
                                        APPLY FILTER
                                    </button>
                                    <p className="filter-note mt-2">
                                        After making your selections, click <strong>"Apply Filter"</strong> to update the results.
                                    </p>
                                </div>


                                <div className="price-filter">
                                    {/* <h3 className="price-filter-text" role="button" onClick={() => setOpenManufacturer(!openManufacturer)}>
                                        Brands <i className={openManufacturer ? "fa fa-minus" : "fa fa-plus"}></i>
                                    </h3> */}
                                    {/* change h3 to p tag in all filter ++++ */}
                                    <p className="price-filter-text" role="button" onClick={() => setOpenManufacturer(!openManufacturer)}>
                                        Brands <i className={openManufacturer ? "fa fa-minus" : "fa fa-plus"}></i>
                                    </p>
                                    <Collapse in={openManufacturer}>
                                        <ul className="p-0 m-0 list-filter">
                                            {availableManufacturers.map(mfr => (
                                                <li key={mfr}>
                                                    <label className="label-filter" htmlFor={mfr}>
                                                        <input
                                                            type="checkbox"
                                                            id={mfr}
                                                            checked={selectedManufacturers.includes(mfr)}
                                                            onChange={() => handleManufacturerChange(mfr)}
                                                            className="filter-box"
                                                        />
                                                        {mfr}
                                                        <label htmlFor={mfr} className="custome-checkboxes"></label>
                                                    </label>
                                                </li>
                                            ))}
                                        </ul>
                                    </Collapse>
                                </div>

                                <div className="price-filter">
                                    <p
                                        className="price-filter-text"
                                        role="button"
                                        onClick={() => setOpenCategory(!openCategory)}
                                    >
                                        Category <i className={openCategory ? "fa fa-minus" : "fa fa-plus"}></i>
                                    </p>
                                    <Collapse in={openCategory}>
                                        <ul className="p-0 m-0 list-filter">
                                            {availableCategories.map(cat => (
                                                <li key={cat}>
                                                    <label className="label-filter" htmlFor={cat}>
                                                        <input
                                                            type="checkbox"
                                                            id={cat}
                                                            checked={selectedCategories.includes(cat)}
                                                            onChange={() => handleCategoryChange(cat)}
                                                            className="filter-box"
                                                        />
                                                        {cat}
                                                        <label htmlFor={cat} className="custome-checkboxes"></label>
                                                    </label>
                                                </li>
                                            ))}
                                        </ul>
                                    </Collapse>
                                </div>

                                <div className="price-filter">
                                    <p
                                        className="price-filter-text"
                                        role="button"
                                        onClick={() => setOpenLift(!openLift)}
                                    >
                                        Lift Kit Size <i className={openLift ? "fa fa-minus" : "fa fa-plus"}></i>
                                    </p>
                                    <Collapse in={openLift}>
                                        <ul className="p-0 m-0 list-filter">
                                            {availableLifts.map(lift => (
                                                <li key={lift}>
                                                    <label className="label-filter" htmlFor={`lift-${lift}`}>
                                                        <input
                                                            type="checkbox"
                                                            id={`lift-${lift}`}
                                                            checked={selectedLifts.includes(lift)}
                                                            onChange={() => handleLiftChange(lift)}
                                                            className="filter-box"
                                                        />
                                                        {lift}
                                                        <label htmlFor={`lift-${lift}`} className="custome-checkboxes"></label>
                                                    </label>
                                                </li>
                                            ))}
                                        </ul>
                                    </Collapse>
                                </div>

                                <div className="price-filter">
                                    <p className="price-filter-text" role="button" onClick={() => setOpenVehicle(!openVehicle)}>
                                        YMM Search <i className={openVehicle ? "fa fa-minus" : "fa fa-plus"}></i>
                                    </p>
                                    <Collapse in={openVehicle}>
                                        <div className="rough-vehicle-filter">
                                            <div className="mb-2">
                                                <Select
                                                    options={years}
                                                    value={year ? { value: year, label: yearLabel } : null}
                                                    onChange={handleYearChange}
                                                    placeholder="Year"
                                                    isLoading={loadingYears}
                                                    isSearchable={true}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    aria-label="Vehicle Year"
                                                />
                                            </div>

                                            <div className="mb-2">
                                                <Select
                                                    ref={makeRef}
                                                    options={makes}
                                                    value={make ? { value: make, label: makeLabel } : null}
                                                    onChange={handleMakeChange}
                                                    placeholder="Make"
                                                    isLoading={loadingMakes}
                                                    isDisabled={!year || loadingMakes}
                                                    isSearchable={true}
                                                    styles={ymmError && !make ? selectErrorStyles : {}}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    aria-label="Vehicle Make"
                                                />
                                            </div>

                                            <div className="mb-2">
                                                <Select
                                                    ref={modelRef}
                                                    options={models}
                                                    value={model ? { value: model, label: modelLabel } : null}
                                                    onChange={handleModelChange}
                                                    placeholder="Model"
                                                    isLoading={loadingModels}
                                                    isDisabled={!make || loadingModels}
                                                    isSearchable={true}
                                                    styles={ymmError && !model ? selectErrorStyles : {}}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    aria-label="Vehicle Model"
                                                />
                                            </div>

                                            <div className="mb-2">
                                                <Select
                                                    ref={submodelRef}
                                                    options={submodels}
                                                    value={submodel ? { value: submodel, label: subLabel } : null}
                                                    onChange={handleSubmodelChange}
                                                    placeholder="Submodel"
                                                    isLoading={loadingSubmodels}
                                                    isDisabled={!model || loadingSubmodels}
                                                    isSearchable={true}
                                                    styles={ymmError && !submodel ? selectErrorStyles : {}}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    aria-label="Vehicle Sub Model"
                                                />
                                            </div>

                                            {/* {hasVehicleSelection && (
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0 text-danger"
                                                    onClick={clearVehicleFilter}
                                                >
                                                    Clear vehicle
                                                </button>
                                            )} */}

                                        </div>
                                    </Collapse>
                                </div>

                                <p className="filter-note">
                                    After making your selections, click <strong>"Apply Filter"</strong> to update the results.
                                </p>

                                <div className="price-filter filter-button">
                                    <div>
                                        <button className='btn btn-danger' onClick={applyFilters}>APPLY FILTER</button>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="col-lg-9 filter-for-mobile">
                            <div className='selectedFilters mb-3'>
                                {hasVehicleSelection && (
                                    <span className="span-filter-Checkbox m-1">
                                        <span>{yearLabel} {makeLabel} {modelLabel} {subLabel}</span>
                                        <i
                                            className="fa fa-times"
                                            aria-hidden="true"
                                            style={{ cursor: 'pointer' }}
                                            onClick={clearVehicleFilter}
                                        ></i>
                                    </span>
                                )}

                                {selectedManufacturers.map(mfr => (
                                    <span className="span-filter-Checkbox m-1" key={mfr}>
                                        <span>{mfr}</span>
                                        <i
                                            className="fa fa-times"
                                            aria-hidden="true"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => removeManufacturer(mfr)}
                                        ></i>
                                    </span>
                                ))}

                                {selectedCategories.map(cat => (
                                    <span className="span-filter-Checkbox m-1" key={cat}>
                                        <span>{cat}</span>
                                        <i
                                            className="fa fa-times"
                                            aria-hidden="true"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => removeCategory(cat)}
                                        ></i>
                                    </span>
                                ))}
                                {selectedLifts.map(lift => (
                                    <span className="span-filter-Checkbox m-1" key={lift}>
                                        <span>{lift}</span>
                                        <i
                                            className="fa fa-times"
                                            aria-hidden="true"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => removeLift(lift)}
                                        ></i>
                                    </span>
                                ))}

                                {(hasVehicleSelection || selectedManufacturers.length > 0 || selectedCategories.length > 0 || selectedLifts.length > 0) && (
                                    <span
                                        className="clearFilterStyle ms-2"
                                        style={{ cursor: 'pointer' }}
                                        onClick={clearAllFilters}
                                    >
                                        Clear filters
                                    </span>
                                )}
                            </div>

                            <div className="d-flex justify-content-end filters-sort-by">
                                <div>
                                    {totalProducts > 0 && (
                                        <p className="px-5">
                                            Showing {startIndex} - {endIndex} of {parseInt(totalProducts).toLocaleString('en-US')} products
                                        </p>
                                    )}
                                </div>

                                <div className="stockCheckbox">
                                    <ul className="stockCheckboxUl">
                                        <li>
                                            <input
                                                type="checkbox"
                                                className="tgl tgl-light"
                                                id="stockCheckRough"
                                                checked={!showInStockOnly}
                                                onChange={handleStockToggle}
                                                aria-label="Stock Checkbox"
                                            />
                                            <label htmlFor="stockCheckRough" className="tgl-btn"></label>
                                        </li>
                                        <li className="staggeredLi">
                                            {showInStockOnly ? <span>In Stock Items</span> : <span>All Items</span>}
                                        </li>
                                    </ul>
                                </div>

                                <div className="sorting-section">
                                    <select
                                        className="form-control"
                                        value={sortingValue}
                                        onChange={handleSorting}
                                        aria-label="Sorting"
                                    >
                                        <option disabled>Sort By Price</option>
                                        <option value={1}>Low-High</option>
                                        <option value={2}>High-Low</option>
                                    </select>
                                </div>

                                <div className="main-headin">
                                    <div className="main-filter-resposive">
                                        <button className="mobile-filter-btn" onClick={showFiltersClick} aria-label="Open filters">
                                            <svg className="me-1" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" key="svg-icon">
                                                <path d="M5.25901 14.35L5.25888 14.35C5.24769 14.3502 5.23405 14.3476 5.21863 14.339L5.21836 14.3389C5.19936 14.3282 5.19074 14.318 5.18703 14.3124C5.17887 14.2972 5.176 14.2839 5.176 14.2707V7.91365C5.176 7.82275 5.1652 7.72056 5.13235 7.61486C5.09945 7.50839 5.04961 7.41561 4.99386 7.33726L0.724519 1.26892C0.724485 1.26887 0.724451 1.26882 0.724418 1.26877C0.676725 1.20083 0.65495 1.13291 0.650688 1.06991C0.64665 1.00345 0.660203 0.933143 0.696549 0.863781L0.696552 0.863774C0.732993 0.794228 0.783357 0.74264 0.84197 0.707465L0.841971 0.707466L0.843135 0.706765C0.902543 0.670943 0.973036 0.65 1.05357 0.65H12.9463C13.0271 0.65 13.0973 0.670932 13.1564 0.706609L13.1578 0.70745C13.2164 0.742594 13.2667 0.794096 13.3032 0.863535C13.3407 0.935416 13.3534 1.00516 13.3492 1.06874C13.345 1.13245 13.3232 1.20066 13.2755 1.26862C13.2755 1.26872 13.2754 1.26882 13.2753 1.26892L9.0045 7.33779L9.00402 7.33848C8.94618 7.42089 8.90098 7.51067 8.86985 7.6068L8.86979 7.60678L8.8672 7.61518C8.83481 7.71999 8.82355 7.82177 8.82355 7.91441V12.1555C8.82355 12.1724 8.81984 12.1838 8.81525 12.1923C8.81075 12.1999 8.8025 12.2101 8.78506 12.2207L8.34805 12.4857L8.34827 12.4864L5.3042 14.3361C5.30409 14.3362 5.30399 14.3362 5.30388 14.3363C5.28736 14.3462 5.27261 14.3497 5.25901 14.35ZM5.27154 14.9999C5.14389 15.0023 5.01635 14.9707 4.90099 14.9061L5.27154 14.9999Z" stroke="#E81C2E" strokeWidth="1.3"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Products Grid */}
                            <div className="row">
                                {isLoading ? (
                                    Array.from({ length: 12 }).map((_, i) => (
                                        <div className="col-lg-3 col-md-4 col-6 mb-1" key={i}>
                                            <ShimmerThumbnail height={320} rounded />
                                        </div>
                                    ))
                                ) : products.length > 0 ? (
                                    products.map((product, i) => (
                                        <div className="col-lg-3 col-md-4 col-6 mb-1" key={product.sku || i}>
                                            <RoughCountryCard data={product} />
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center py-5">
                                        <h3>No products found</h3>
                                        <p>
                                            {showInStockOnly
                                                ? "No in-stock Rough Country products found."
                                                : "No Rough Country products found at the moment."}
                                        </p>
                                    </div>
                                )}
                            </div>

                            {/* Pagination */}
                            {totalPages > 1 && (
                                <div className="d-flex justify-content-center mt-5">
                                    <Pagination>
                                        <Pagination.First disabled={currentPage === 1} onClick={() => handlePageChange(1)} />
                                        <Pagination.Prev disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)} />
                                        {getPageNumbers().map(page => (
                                            <Pagination.Item
                                                key={page}
                                                active={page === currentPage}
                                                onClick={() => handlePageChange(page)}
                                            >
                                                {page}
                                            </Pagination.Item>
                                        ))}
                                        <Pagination.Next disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)} />
                                        <Pagination.Last disabled={currentPage === totalPages} onClick={() => handlePageChange(totalPages)} />
                                    </Pagination>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <FOOTER />
        </>
    );
}







// import React, { useState, useEffect, useRef } from 'react';
// import { Helmet } from 'react-helmet';
// import axios from 'axios';
// import Select from 'react-select';
// import TOPBAR from "../../components/TopBar";
// import SEARCHBAR from "../../components/SeachBar";
// import MENUBAR from "../../components/Menu";
// import FOOTER from "../../components/Footer";
// import RoughCountryCard from '../../components/Cards/rough-country-card';
// import Pagination from 'react-bootstrap/Pagination';
// import { ShimmerThumbnail } from "react-shimmer-effects";
// import Collapse from 'react-bootstrap/Collapse';

// export default function RoughCountry() {
//     const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
//     const PRODUCTS_PER_PAGE = 28;
//     const MAX_PAGES_DISPLAY = 10;

//     const [products, setProducts] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [offset, setOffset] = useState(0);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalProducts, setTotalProducts] = useState(0);
//     const [isHidden, setIsHidden] = useState(false);
//     const [selectedManufacturers, setSelectedManufacturers] = useState([]);
//     const [showInStockOnly, setShowInStockOnly] = useState(true);
//     const [sortingValue, setSortingValue] = useState(1);
//     const [selectedCategories, setSelectedCategories] = useState([]);
//     const [availableCategories, setAvailableCategories] = useState([]);
//     const [openCategory, setOpenCategory] = useState(false);
//     const [availableManufacturers, setAvailableManufacturers] = useState([]);
//     const [openManufacturer, setOpenManufacturer] = useState(true);
//     const [applyTrigger, setApplyTrigger] = useState(false);
//     const [selectedLifts, setSelectedLifts] = useState([]);
//     const [availableLifts, setAvailableLifts] = useState([]);
//     const [openLift, setOpenLift] = useState(false);
//     const [filterClass, setFilterClass] = useState('');
//     // const [openVehicle, setOpenVehicle] = useState(false);

//     const storedVehicle = JSON.parse(localStorage.getItem('vehical_details') || '{}');
//     const [openVehicle, setOpenVehicle] = useState(Object.keys(storedVehicle).length > 0);

//     const [years, setYears] = useState([]);
//     const [makes, setMakes] = useState([]);
//     const [models, setModels] = useState([]);
//     const [submodels, setSubmodels] = useState([]);
//     const [loadingYears, setLoadingYears] = useState(false);
//     const [loadingMakes, setLoadingMakes] = useState(false);
//     const [loadingModels, setLoadingModels] = useState(false);
//     const [loadingSubmodels, setLoadingSubmodels] = useState(false);
//     const [year, setYear] = useState(storedVehicle?.year || '');
//     const [make, setMake] = useState(storedVehicle?.make || '');
//     const [model, setModel] = useState(storedVehicle?.model || '');
//     const [submodel, setSubmodel] = useState(storedVehicle?.variant || '');
//     const [yearLabel, setYearLabel] = useState(storedVehicle?.yearLabel || storedVehicle?.year || 'Year');
//     const [makeLabel, setMakeLabel] = useState(storedVehicle?.makeLabel || storedVehicle?.make_name || 'Make');
//     const [modelLabel, setModelLabel] = useState(storedVehicle?.modelLabel || storedVehicle?.model_name || 'Model');
//     const [subLabel, setSubLabel] = useState(storedVehicle?.variantLabel || storedVehicle?.variant_name || 'Submodel');

//     const makeRef = useRef(null);
//     const modelRef = useRef(null);
//     const submodelRef = useRef(null);
//     const hasVehicleSelection = !!year && !!make && !!model && !!submodel;


//     const startIndex = (currentPage - 1) * PRODUCTS_PER_PAGE + 1;
//     const endIndex = Math.min(startIndex + PRODUCTS_PER_PAGE - 1, totalProducts);

//     const [cartItems, setCartItems] = useState("");
//     const [showMenuSide, setShowMenuSide] = useState("");
//     const [ymmError, setYmmError] = useState(false);


//     const setValueMenuSideBar = (value) => {
//         setShowMenuSide(value);
//     };


//     useEffect(() => {
//         const savedSorting = localStorage.getItem('rough_sortingValue');
//         if (savedSorting) setSortingValue(JSON.parse(savedSorting));

//         const savedStock = localStorage.getItem('rough_inStockOnly');
//         if (savedStock !== null) setShowInStockOnly(JSON.parse(savedStock));

//         const savedManufacturers = localStorage.getItem('rough_manufacturers');
//         if (savedManufacturers) setSelectedManufacturers(JSON.parse(savedManufacturers));

//         const savedCategories = localStorage.getItem('rough_categories');
//         if (savedCategories) setSelectedCategories(JSON.parse(savedCategories));

//         const savedLifts = localStorage.getItem('rough_lifts');
//         if (savedLifts) setSelectedLifts(JSON.parse(savedLifts));

//         setApplyTrigger(prev => !prev);

//     }, []);

//     useEffect(() => {
//         loadYears();
//     }, []);

//     useEffect(() => {
//         if (!storedVehicle?.year) return;

//         loadMakes(storedVehicle.year);

//         if (!storedVehicle?.make) return;
//         loadModels(storedVehicle.year, storedVehicle.make);

//         if (!storedVehicle?.model) return;
//         loadSubmodels(storedVehicle.year, storedVehicle.model);
//     }, []);

//     useEffect(() => {
//         if (years.length > 0 && year) {
//             const found = years.find(opt => String(opt.value) === String(year));
//             if (found) setYearLabel(found.label);
//         }
//     }, [years, year]);

//     useEffect(() => {
//         if (makes.length > 0 && make) {
//             const found = makes.find(opt => String(opt.value) === String(make));
//             if (found) setMakeLabel(found.label);
//         }
//     }, [makes, make]);

//     useEffect(() => {
//         if (models.length > 0 && model) {
//             const found = models.find(opt => String(opt.value) === String(model));
//             if (found) setModelLabel(found.label);
//         }
//     }, [models, model]);

//     useEffect(() => {
//         if (submodels.length > 0 && submodel) {
//             const found = submodels.find(opt => String(opt.value) === String(submodel));
//             if (found) setSubLabel(found.label);
//         }
//     }, [submodels, submodel]);

//     useEffect(() => {
//         if (!hasVehicleSelection) return;

//         localStorage.setItem('vehical_details', JSON.stringify({
//             year,
//             make,
//             model,
//             variant: submodel,
//             make_name: makeLabel,
//             model_name: modelLabel,
//             variant_name: subLabel,
//         }));
//     }, [hasVehicleSelection, year, make, model, submodel, makeLabel, modelLabel, subLabel]);


//     useEffect(() => {
//         localStorage.setItem('rough_manufacturers', JSON.stringify(selectedManufacturers));
//         localStorage.setItem('rough_categories', JSON.stringify(selectedCategories));
//         localStorage.setItem('rough_lifts', JSON.stringify(selectedLifts));
//         localStorage.setItem('rough_inStockOnly', JSON.stringify(showInStockOnly));
//         localStorage.setItem('rough_sortingValue', JSON.stringify(sortingValue));
//     }, [selectedManufacturers, selectedCategories, selectedLifts, showInStockOnly, sortingValue]);

//     // Load cart items count
//     useEffect(() => {
//         const storedCartItems = localStorage.getItem('totalCartItems');
//         if (storedCartItems) {
//             const parsedCartItems = JSON.parse(storedCartItems);
//             const numCartItems = Object.values(parsedCartItems);
//             const sum = numCartItems.reduce((acc, val) => acc + val, 0);
//             setCartItems(sum);
//         }
//     }, []);

//     // Main data fetching effect
//     useEffect(() => {
//         const fetchData = async () => {
//             setIsLoading(true);
//             document.body.classList.add('full-screen-loader');

//             try {
//                 let params = {
//                     limit: PRODUCTS_PER_PAGE,
//                     page: currentPage,
//                     sorting: sortingValue,
//                 };

//                 if (showInStockOnly) params.inStock = true;
//                 if (selectedManufacturers.length > 0) params.manufacturer = selectedManufacturers.join(',');
//                 if (selectedCategories.length > 0) params.category = selectedCategories.join(',');
//                 if (selectedLifts.length > 0) params.lift = selectedLifts.join(',');
//                 if (hasVehicleSelection) {
//                     params.year = year;
//                     params.make = makeLabel;
//                     params.model = modelLabel;
//                     params.variant = subLabel;
//                 }

//                 const response = await axios.get(`${mainUrl}/api/rough/getAllRoughCountryData`, { params });

//                 setProducts(response.data.data || []);
//                 setTotalPages(response.data.totalPages || 1);
//                 setTotalProducts(response.data.count || 0);
//                 setIsHidden(true);

//                 if (response.data.availableManufacturers) {
//                     setAvailableManufacturers(response.data.availableManufacturers);
//                 } else if (availableManufacturers.length === 0 && response.data.data) {
//                     const unique = [...new Set(response.data.data.map(p => p.manufacturer))].filter(Boolean);
//                     setAvailableManufacturers(unique);
//                 }

//                 if (response.data.availableCategories) {
//                     setAvailableCategories(response.data.availableCategories);
//                 } else if (availableCategories.length === 0 && response.data.data) {
//                     const unique = [...new Set(response.data.data.map(p => p.category))].filter(Boolean);
//                     setAvailableCategories(unique);
//                 }

//                 if (response.data.availableLifts) {
//                     setAvailableLifts(response.data.availableLifts);
//                 } else if (availableLifts.length === 0 && response.data.data) {
//                     const unique = [...new Set(response.data.data.map(p => p.kit_type))].filter(Boolean);
//                     setAvailableLifts(unique);
//                 }

//             } catch (err) {
//                 console.error("Fetch error:", err);
//             } finally {
//                 setIsLoading(false);
//                 document.body.classList.remove('full-screen-loader');
//             }
//         };

//         fetchData();
//         window.scrollTo({ top: 400, behavior: 'smooth' });

//     }, [currentPage, sortingValue, showInStockOnly, applyTrigger]);

//     const loadYears = async () => {
//         setLoadingYears(true);
//         try {
//             const { data } = await axios.get(`${mainUrl}/api/getYear`);
//             setYears(data?.data || []);
//         } catch (err) {
//             console.error('Failed to load years', err);
//         } finally {
//             setLoadingYears(false);
//         }
//     };

//     const loadMakes = async (yr) => {
//         if (!yr) return;
//         setLoadingMakes(true);
//         try {
//             const { data } = await axios.get(`${mainUrl}/api/getMakeByYear/${yr}`);
//             setMakes(data?.data || []);
//         } catch (err) {
//             console.error('Failed to load makes', err);
//         } finally {
//             setLoadingMakes(false);
//         }
//     };

//     const loadModels = async (yr, mk) => {
//         if (!yr || !mk) return;
//         setLoadingModels(true);
//         try {
//             const { data } = await axios.get(`${mainUrl}/api/getModelByMake/${yr}/${mk}`);
//             setModels(data?.data || []);
//         } catch (err) {
//             console.error('Failed to load models', err);
//         } finally {
//             setLoadingModels(false);
//         }
//     };

//     const loadSubmodels = async (yr, md) => {
//         if (!yr || !md) return;
//         setLoadingSubmodels(true);
//         try {
//             const { data } = await axios.get(`${mainUrl}/api/getSubModelByModel/${yr}/${md}`);
//             setSubmodels(data?.data || []);
//         } catch (err) {
//             console.error('Failed to load submodels', err);
//         } finally {
//             setLoadingSubmodels(false);
//         }
//     };

//     const handleYearChange = (option) => {
//         if (!option) return;
//         setYear(option.value);
//         setYearLabel(option.label);
//         setMake('');
//         setMakeLabel('Make');
//         setModel('');
//         setModelLabel('Model');
//         setSubmodel('');
//         setSubLabel('Submodel');
//         setMakes([]);
//         setModels([]);
//         setSubmodels([]);
//         // localStorage.removeItem('vehical_details');
//         loadMakes(option.value);
//         setTimeout(() => makeRef.current?.focus(), 100);
//     };

//     const handleMakeChange = (option) => {
//         if (!option) return;
//         setMake(option.value);
//         setMakeLabel(option.label);
//         setModel('');
//         setModelLabel('Model');
//         setSubmodel('');
//         setSubLabel('Submodel');
//         setModels([]);
//         setSubmodels([]);
//         // localStorage.removeItem('vehical_details');
//         loadModels(year, option.value);
//         setTimeout(() => modelRef.current?.focus(), 100);
//     };

//     const handleModelChange = (option) => {
//         if (!option) return;
//         setModel(option.value);
//         setModelLabel(option.label);
//         setSubmodel('');
//         setSubLabel('Submodel');
//         setSubmodels([]);
//         // localStorage.removeItem('vehical_details');
//         loadSubmodels(year, option.value);
//         setTimeout(() => submodelRef.current?.focus(), 100);
//     };

//     // const handleSubmodelChange = (option) => {
//     //     if (!option) return;
//     //     setSubmodel(option.value);
//     //     setSubLabel(option.label);
//     //     // window.location.reload();
//     // };

//     const handleSubmodelChange = (option) => {
//         if (!option) return;
//         setSubmodel(option.value);
//         setSubLabel(option.label);

//         const state = {
//             year,
//             make,
//             model,
//             variant: option.value,
//             make_name: makeLabel,
//             model_name: modelLabel,
//             variant_name: option.label,
//         };

//         localStorage.setItem('vehical_details', JSON.stringify(state));
//         window.dispatchEvent(new Event('vehicleUpdated'));
//     };

//     const clearVehicleFilter = () => {
//         setYear('');
//         setYearLabel('Year');
//         setMake('');
//         setMakeLabel('Make');
//         setModel('');
//         setModelLabel('Model');
//         setSubmodel('');
//         setSubLabel('Submodel');
//         setMakes([]);
//         setModels([]);
//         setSubmodels([]);
//         localStorage.removeItem('vehical_details');
//         // window.location.reload();
//         window.dispatchEvent(new Event('vehicleUpdated'));

//     };

//     const handlePageChange = (page) => {
//         if (page < 1 || page > totalPages) return;
//         setCurrentPage(page);
//         setOffset((page - 1) * PRODUCTS_PER_PAGE);
//     };

//     const getPageNumbers = () => {
//         const totalDisplay = Math.min(totalPages, MAX_PAGES_DISPLAY);
//         const middle = Math.ceil(totalDisplay / 2);
//         let start = Math.max(1, currentPage - middle + 1);
//         if (start + totalDisplay - 1 > totalPages) {
//             start = Math.max(1, totalPages - totalDisplay + 1);
//         }
//         return Array.from({ length: totalDisplay }, (_, i) => start + i);
//     };

//     const handleSorting = (e) => {
//         setSortingValue(parseInt(e.target.value));
//     };

//     const handleStockToggle = () => {
//         setShowInStockOnly(prev => !prev);
//     };

//     const handleManufacturerChange = (mfr) => {
//         setSelectedManufacturers(prev =>
//             prev.includes(mfr) ? prev.filter(x => x !== mfr) : [...prev, mfr]
//         );
//     };

//     const handleCategoryChange = (cat) => {
//         setSelectedCategories(prev =>
//             prev.includes(cat) ? prev.filter(x => x !== cat) : [...prev, cat]
//         );
//     };

//     const handleLiftChange = (lift) => {
//         setSelectedLifts(prev =>
//             prev.includes(lift) ? prev.filter(x => x !== lift) : [...prev, lift]
//         );
//     };

//     // const applyFilters = () => {
//     //     setCurrentPage(1);
//     //     setOffset(0);
//     //     setApplyTrigger(prev => !prev);

//     //     setFilterClass('')
//     //     document.body.classList.remove('home-layout')

//     //     window.scrollTo({ top: 400, behavior: 'smooth' });
//     // };

//     const applyFilters = () => {

//         // If user started YMM selection but not completed
//         const partialSelection =
//             year || make || model || submodel;

//         const completeSelection =
//             year && make && model && submodel;

//         if (partialSelection && !completeSelection) {
//             setYmmError(true);
//             return;
//         }

//         setYmmError(false);

//         setCurrentPage(1);
//         setOffset(0);
//         setApplyTrigger(prev => !prev);

//         setFilterClass('');
//         document.body.classList.remove('home-layout');

//         window.scrollTo({ top: 400, behavior: 'smooth' });
//     };

//     useEffect(() => {
//         const completeSelection =
//             year && make && model && submodel;

//         if (completeSelection) {
//             setYmmError(false);
//         }
//     }, [year, make, model, submodel]);

//     const selectErrorStyles = {
//         control: (base) => ({
//             ...base,
//             borderColor: 'red',
//             boxShadow: 'none',
//             '&:hover': {
//                 borderColor: 'red'
//             }
//         })
//     };

//     const clearAllFilters = () => {
//         setSelectedManufacturers([]);
//         setSelectedCategories([]);
//         setSelectedLifts([]);
//         clearVehicleFilter();
//         setShowInStockOnly(true);
//         setSortingValue(1);
//         setCurrentPage(1);
//         setOffset(0);
//         setApplyTrigger(prev => !prev);
//     };

//     const removeManufacturer = (mfr) => {
//         setSelectedManufacturers(prev => prev.filter(item => item !== mfr));
//     };

//     const removeCategory = (cat) => {
//         setSelectedCategories(prev => prev.filter(item => item !== cat));
//     };

//     const removeLift = (lift) => {
//         setSelectedLifts(prev => prev.filter(item => item !== lift));
//     };


//     const showFiltersClick = () => {
//         setFilterClass('active-filter')
//         document.body.classList.add('home-layout')

//     }
//     const hideFilterClass = () => {
//         setFilterClass('')
//         document.body.classList.remove('home-layout')
//     }


//     return (
//         <>
//             <Helmet>
//                 <title>Rough Country</title>
//                 <meta name="description" content="Explore the full range of Rough Country" />
//             </Helmet>

//             <TOPBAR isHidden={isHidden} />
//             <SEARCHBAR setValueMenuSideBar={setValueMenuSideBar} cartItemsdata={cartItems} />
//             <MENUBAR showMenuSide={showMenuSide} setValueMenuSideBar={setValueMenuSideBar} />

//             <div className="main-inner-banner">
//                 <div className="parformane-bar">
//                     <div className="container d-flex justify-content-between">
//                         <ul className="p-0 m-0 listing-parmofamne">
//                             <li><a href="/">Home /</a></li>
//                             <li className="active-bread text-decoration-none"><a href="#">Rough Country</a></li>
//                         </ul>
//                     </div>
//                 </div>
//                 <h2 className="text-center txt-main-listing">Rough Country</h2>
//             </div>

//             <section className="main-section-lsting">
//                 <div className="container">

//                     <div className="row">
//                         {/* Sidebar */}
//                         <div className="col-lg-3">
//                             {/* <div className="main-outer-filter"> */}
//                             <div className={`main-outer-filter ${filterClass}`}>

//                                 <div className="filter-crose" id="close-bar">
//                                     <button className="abc" onClick={hideFilterClass}>
//                                         <img src="/images/x-mark.svg" alt="img" height="100%" width="100%" />
//                                     </button>
//                                 </div>

//                                 <div className="price-filter filter-button">
//                                     <button className="btn btn-danger" onClick={applyFilters}>
//                                         APPLY FILTER
//                                     </button>
//                                     <p className="filter-note mt-2">
//                                         After making your selections, click <strong>"Apply Filter"</strong> to update the results.
//                                     </p>
//                                 </div>


//                                 <div className="price-filter">
//                                     {/* <h3 className="price-filter-text" role="button" onClick={() => setOpenManufacturer(!openManufacturer)}>
//                                         Brands <i className={openManufacturer ? "fa fa-minus" : "fa fa-plus"}></i>
//                                     </h3> */}
//                                     {/* change h3 to p tag in all filter ++++ */}
//                                     <p className="price-filter-text" role="button" onClick={() => setOpenManufacturer(!openManufacturer)}>
//                                         Brands <i className={openManufacturer ? "fa fa-minus" : "fa fa-plus"}></i>
//                                     </p>
//                                     <Collapse in={openManufacturer}>
//                                         <ul className="p-0 m-0 list-filter">
//                                             {availableManufacturers.map(mfr => (
//                                                 <li key={mfr}>
//                                                     <label className="label-filter" htmlFor={mfr}>
//                                                         <input
//                                                             type="checkbox"
//                                                             id={mfr}
//                                                             checked={selectedManufacturers.includes(mfr)}
//                                                             onChange={() => handleManufacturerChange(mfr)}
//                                                             className="filter-box"
//                                                         />
//                                                         {mfr}
//                                                         <label htmlFor={mfr} className="custome-checkboxes"></label>
//                                                     </label>
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     </Collapse>
//                                 </div>

//                                 <div className="price-filter">
//                                     <p
//                                         className="price-filter-text"
//                                         role="button"
//                                         onClick={() => setOpenCategory(!openCategory)}
//                                     >
//                                         Category <i className={openCategory ? "fa fa-minus" : "fa fa-plus"}></i>
//                                     </p>
//                                     <Collapse in={openCategory}>
//                                         <ul className="p-0 m-0 list-filter">
//                                             {availableCategories.map(cat => (
//                                                 <li key={cat}>
//                                                     <label className="label-filter" htmlFor={cat}>
//                                                         <input
//                                                             type="checkbox"
//                                                             id={cat}
//                                                             checked={selectedCategories.includes(cat)}
//                                                             onChange={() => handleCategoryChange(cat)}
//                                                             className="filter-box"
//                                                         />
//                                                         {cat}
//                                                         <label htmlFor={cat} className="custome-checkboxes"></label>
//                                                     </label>
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     </Collapse>
//                                 </div>

//                                 <div className="price-filter">
//                                     <p
//                                         className="price-filter-text"
//                                         role="button"
//                                         onClick={() => setOpenLift(!openLift)}
//                                     >
//                                         Lift Kit Size <i className={openLift ? "fa fa-minus" : "fa fa-plus"}></i>
//                                     </p>
//                                     <Collapse in={openLift}>
//                                         <ul className="p-0 m-0 list-filter">
//                                             {availableLifts.map(lift => (
//                                                 <li key={lift}>
//                                                     <label className="label-filter" htmlFor={`lift-${lift}`}>
//                                                         <input
//                                                             type="checkbox"
//                                                             id={`lift-${lift}`}
//                                                             checked={selectedLifts.includes(lift)}
//                                                             onChange={() => handleLiftChange(lift)}
//                                                             className="filter-box"
//                                                         />
//                                                         {lift}
//                                                         <label htmlFor={`lift-${lift}`} className="custome-checkboxes"></label>
//                                                     </label>
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     </Collapse>
//                                 </div>

//                                 <div className="price-filter">
//                                     <p className="price-filter-text" role="button" onClick={() => setOpenVehicle(!openVehicle)}>
//                                         YMM Search <i className={openVehicle ? "fa fa-minus" : "fa fa-plus"}></i>
//                                     </p>
//                                     <Collapse in={openVehicle}>
//                                         <div className="rough-vehicle-filter">
//                                             <div className="mb-2">
//                                                 <Select
//                                                     options={years}
//                                                     value={year ? { value: year, label: yearLabel } : null}
//                                                     onChange={handleYearChange}
//                                                     placeholder="Year"
//                                                     isLoading={loadingYears}
//                                                     isSearchable={true}
//                                                     className="react-select-container"
//                                                     classNamePrefix="react-select"
//                                                     aria-label="Vehicle Year"
//                                                 />
//                                             </div>

//                                             <div className="mb-2">
//                                                 <Select
//                                                     ref={makeRef}
//                                                     options={makes}
//                                                     value={make ? { value: make, label: makeLabel } : null}
//                                                     onChange={handleMakeChange}
//                                                     placeholder="Make"
//                                                     isLoading={loadingMakes}
//                                                     isDisabled={!year || loadingMakes}
//                                                     isSearchable={true}
//                                                     styles={ymmError && !make ? selectErrorStyles : {}}
//                                                     className="react-select-container"
//                                                     classNamePrefix="react-select"
//                                                     aria-label="Vehicle Make"
//                                                 />
//                                             </div>

//                                             <div className="mb-2">
//                                                 <Select
//                                                     ref={modelRef}
//                                                     options={models}
//                                                     value={model ? { value: model, label: modelLabel } : null}
//                                                     onChange={handleModelChange}
//                                                     placeholder="Model"
//                                                     isLoading={loadingModels}
//                                                     isDisabled={!make || loadingModels}
//                                                     isSearchable={true}
//                                                     styles={ymmError && !model ? selectErrorStyles : {}}
//                                                     className="react-select-container"
//                                                     classNamePrefix="react-select"
//                                                     aria-label="Vehicle Model"
//                                                 />
//                                             </div>

//                                             <div className="mb-2">
//                                                 <Select
//                                                     ref={submodelRef}
//                                                     options={submodels}
//                                                     value={submodel ? { value: submodel, label: subLabel } : null}
//                                                     onChange={handleSubmodelChange}
//                                                     placeholder="Submodel"
//                                                     isLoading={loadingSubmodels}
//                                                     isDisabled={!model || loadingSubmodels}
//                                                     isSearchable={true}
//                                                     styles={ymmError && !submodel ? selectErrorStyles : {}}
//                                                     className="react-select-container"
//                                                     classNamePrefix="react-select"
//                                                     aria-label="Vehicle Sub Model"
//                                                 />
//                                             </div>

//                                             {/* {hasVehicleSelection && (
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-link p-0 text-danger"
//                                                     onClick={clearVehicleFilter}
//                                                 >
//                                                     Clear vehicle
//                                                 </button>
//                                             )} */}

//                                         </div>
//                                     </Collapse>
//                                 </div>

//                                 <p className="filter-note">
//                                     After making your selections, click <strong>"Apply Filter"</strong> to update the results.
//                                 </p>

//                                 <div className="price-filter filter-button">
//                                     <div>
//                                         <button className='btn btn-danger' onClick={applyFilters}>APPLY FILTER</button>
//                                     </div>
//                                 </div>

//                             </div>
//                         </div>

//                         <div className="col-lg-9 filter-for-mobile">
//                             <div className='selectedFilters mb-3'>
//                                 {hasVehicleSelection && (
//                                     <span className="span-filter-Checkbox m-1">
//                                         <span>{yearLabel} {makeLabel} {modelLabel} {subLabel}</span>
//                                         <i
//                                             className="fa fa-times"
//                                             aria-hidden="true"
//                                             style={{ cursor: 'pointer' }}
//                                             onClick={clearVehicleFilter}
//                                         ></i>
//                                     </span>
//                                 )}

//                                 {selectedManufacturers.map(mfr => (
//                                     <span className="span-filter-Checkbox m-1" key={mfr}>
//                                         <span>{mfr}</span>
//                                         <i
//                                             className="fa fa-times"
//                                             aria-hidden="true"
//                                             style={{ cursor: 'pointer' }}
//                                             onClick={() => removeManufacturer(mfr)}
//                                         ></i>
//                                     </span>
//                                 ))}

//                                 {selectedCategories.map(cat => (
//                                     <span className="span-filter-Checkbox m-1" key={cat}>
//                                         <span>{cat}</span>
//                                         <i
//                                             className="fa fa-times"
//                                             aria-hidden="true"
//                                             style={{ cursor: 'pointer' }}
//                                             onClick={() => removeCategory(cat)}
//                                         ></i>
//                                     </span>
//                                 ))}
//                                 {selectedLifts.map(lift => (
//                                     <span className="span-filter-Checkbox m-1" key={lift}>
//                                         <span>{lift}</span>
//                                         <i
//                                             className="fa fa-times"
//                                             aria-hidden="true"
//                                             style={{ cursor: 'pointer' }}
//                                             onClick={() => removeLift(lift)}
//                                         ></i>
//                                     </span>
//                                 ))}

//                                 {(hasVehicleSelection || selectedManufacturers.length > 0 || selectedCategories.length > 0 || selectedLifts.length > 0) && (
//                                     <span
//                                         className="clearFilterStyle ms-2"
//                                         style={{ cursor: 'pointer' }}
//                                         onClick={clearAllFilters}
//                                     >
//                                         Clear filters
//                                     </span>
//                                 )}
//                             </div>

//                             <div className="d-flex justify-content-end filters-sort-by">
//                                 <div>
//                                     {totalProducts > 0 && (
//                                         <p className="px-5">
//                                             Showing {startIndex} - {endIndex} of {parseInt(totalProducts).toLocaleString('en-US')} products
//                                         </p>
//                                     )}
//                                 </div>

//                                 <div className="stockCheckbox">
//                                     <ul className="stockCheckboxUl">
//                                         <li>
//                                             <input
//                                                 type="checkbox"
//                                                 className="tgl tgl-light"
//                                                 id="stockCheckRough"
//                                                 checked={!showInStockOnly}
//                                                 onChange={handleStockToggle}
//                                                 aria-label="Stock Checkbox"
//                                             />
//                                             <label htmlFor="stockCheckRough" className="tgl-btn"></label>
//                                         </li>
//                                         <li className="staggeredLi">
//                                             {showInStockOnly ? <span>In Stock Items</span> : <span>All Items</span>}
//                                         </li>
//                                     </ul>
//                                 </div>

//                                 <div className="sorting-section">
//                                     <select
//                                         className="form-control"
//                                         value={sortingValue}
//                                         onChange={handleSorting}
//                                         aria-label="Sorting"
//                                     >
//                                         <option disabled>Sort By Price</option>
//                                         <option value={1}>Low-High</option>
//                                         <option value={2}>High-Low</option>
//                                     </select>
//                                 </div>

//                                 <div className="main-headin">
//                                     <div className="main-filter-resposive">
//                                         <button className="mobile-filter-btn" onClick={showFiltersClick} aria-label="Open filters">
//                                             <svg className="me-1" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" key="svg-icon">
//                                                 <path d="M5.25901 14.35L5.25888 14.35C5.24769 14.3502 5.23405 14.3476 5.21863 14.339L5.21836 14.3389C5.19936 14.3282 5.19074 14.318 5.18703 14.3124C5.17887 14.2972 5.176 14.2839 5.176 14.2707V7.91365C5.176 7.82275 5.1652 7.72056 5.13235 7.61486C5.09945 7.50839 5.04961 7.41561 4.99386 7.33726L0.724519 1.26892C0.724485 1.26887 0.724451 1.26882 0.724418 1.26877C0.676725 1.20083 0.65495 1.13291 0.650688 1.06991C0.64665 1.00345 0.660203 0.933143 0.696549 0.863781L0.696552 0.863774C0.732993 0.794228 0.783357 0.74264 0.84197 0.707465L0.841971 0.707466L0.843135 0.706765C0.902543 0.670943 0.973036 0.65 1.05357 0.65H12.9463C13.0271 0.65 13.0973 0.670932 13.1564 0.706609L13.1578 0.70745C13.2164 0.742594 13.2667 0.794096 13.3032 0.863535C13.3407 0.935416 13.3534 1.00516 13.3492 1.06874C13.345 1.13245 13.3232 1.20066 13.2755 1.26862C13.2755 1.26872 13.2754 1.26882 13.2753 1.26892L9.0045 7.33779L9.00402 7.33848C8.94618 7.42089 8.90098 7.51067 8.86985 7.6068L8.86979 7.60678L8.8672 7.61518C8.83481 7.71999 8.82355 7.82177 8.82355 7.91441V12.1555C8.82355 12.1724 8.81984 12.1838 8.81525 12.1923C8.81075 12.1999 8.8025 12.2101 8.78506 12.2207L8.34805 12.4857L8.34827 12.4864L5.3042 14.3361C5.30409 14.3362 5.30399 14.3362 5.30388 14.3363C5.28736 14.3462 5.27261 14.3497 5.25901 14.35ZM5.27154 14.9999C5.14389 15.0023 5.01635 14.9707 4.90099 14.9061L5.27154 14.9999Z" stroke="#E81C2E" strokeWidth="1.3"></path>
//                                             </svg>
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Products Grid */}
//                             <div className="row">
//                                 {isLoading ? (
//                                     Array.from({ length: 12 }).map((_, i) => (
//                                         <div className="col-lg-3 col-md-4 col-6 mb-1" key={i}>
//                                             <ShimmerThumbnail height={320} rounded />
//                                         </div>
//                                     ))
//                                 ) : products.length > 0 ? (
//                                     products.map((product, i) => (
//                                         <div className="col-lg-3 col-md-4 col-6 mb-1" key={product.sku || i}>
//                                             <RoughCountryCard data={product} />
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <div className="col-12 text-center py-5">
//                                         <h3>No products found</h3>
//                                         <p>
//                                             {showInStockOnly
//                                                 ? "No in-stock Rough Country products found."
//                                                 : "No Rough Country products found at the moment."}
//                                         </p>
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Pagination */}
//                             {totalPages > 1 && (
//                                 <div className="d-flex justify-content-center mt-5">
//                                     <Pagination>
//                                         <Pagination.First disabled={currentPage === 1} onClick={() => handlePageChange(1)} />
//                                         <Pagination.Prev disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)} />
//                                         {getPageNumbers().map(page => (
//                                             <Pagination.Item
//                                                 key={page}
//                                                 active={page === currentPage}
//                                                 onClick={() => handlePageChange(page)}
//                                             >
//                                                 {page}
//                                             </Pagination.Item>
//                                         ))}
//                                         <Pagination.Next disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)} />
//                                         <Pagination.Last disabled={currentPage === totalPages} onClick={() => handlePageChange(totalPages)} />
//                                     </Pagination>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             <FOOTER />
//         </>
//     );
// }
